import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { CustomSelectDropdown } from "./custom.select";
import { selectStyle } from "../../../shared/fixtures/select_style";
import { getStates } from "../../../shared/helpers/util.country";
import { P } from "../Texts";

export const StateSelect = (props) => {
  const formCtx = useFormContext();
  const {
    watch,
    formState: { errors: formStateErrors },
  } = formCtx;

  const [states, setStates] = useState([]);
  const { country } = props;

  const country_value = watch(country);

  const getSpecificStates = async () => {
    const states = await getStates({ country: country_value.label });
    // setStateInputsArray({ ...stateInputsArray, [inputId]: states });
    setStates(states);
  };

  useEffect(() => {
    if (country_value?.label) {
      getSpecificStates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country_value]);
  return (
    <div className="mb-4">
      <label htmlFor={props.name}>
        <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
          State
          <span
            className=""
            style={{
              color: "#E62250",
            }}
          >
            *
          </span>
        </P>
      </label>

      <Controller
        control={props.control}
        {...props}
        defaultValue=""
        rules={{ required: true }}
        render={({ field }) => (
          <CustomSelectDropdown
            autoComplete="true"
            styles={selectStyle}
            {...field}
            placeholder="--Select a state--"
            className="w-full"
            options={states}
            isLoading={states?.length === 0}
            isDisabled={states?.length === 0}
          />
        )}
      />

      {formStateErrors[props.name] && (
        <P fontSize="12px" className="mt-2 mb-4 text-red-400 text-sm">
          Select a state
        </P>
      )}
    </div>
  );
};
